import React, { useState, useRef, useEffect } from "react";
import { Card, Form, Table, Button, Row, Col } from "react-bootstrap";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import Dropdown from "react-bootstrap/Dropdown";
import Loading from "../../shared/Loading.js";
import { DateFormat } from "../../Helper.js";
import { useContext } from "react";
import api from "../../services/api.js";
import {
  ErxAdviceContext,
  ErxAdviceDispatchContext,
} from "../../context/ErxContext.js";
import patientService from "../../services/patient.service.js";
function ErxAdvices({
  adviceType,
  id,
  dataSource,
  typeaheadId,
  fields,
  thGroups,
  variant,
  adviceSubmitUrl,
  extraReferences,
  extraData,
  newEntryForm = true,
}) {
  const adviceNoted = useContext(ErxAdviceContext);
  const setAdviceNoted = useContext(ErxAdviceDispatchContext);
  const [isLoading, setIsLoading] = useState(true);
  const [typeAheadLoading, setTypeAheadLoading] = useState(false);
  const adviceRef = useRef({});
  const [typeAheadSelection, setTypeAheadSelection] = useState([]);
  const [isValidated, setValidated] = useState(false);
  const [editFormValidated, setEditFormValidated] = useState(false);

  const key = adviceType.replace(/ /g, "_");
  useEffect(() => {
    if (!adviceNoted[key]) {
      setAdviceNoted({ type: "init", key: key });
    }
    setIsLoading(false);
  }, []);

  const handleSearch = async (query) => {
    try {
      setTypeAheadLoading(true);

      // Make your API request here to fetch options based on the query
      const data = await patientService.searchService(query);
      if (data === false) throw new Error("Something went wrong");

      setTypeAheadSelection(data);
      setTypeAheadLoading(false);

      return data;
    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };
  const handleEditSearch = async (query, timestamp) => {
    try {
      // Make your API request here to fetch options based on the query
      const response = await fetch(`${dataSource}q=${query}`);
      const data = await response.json();

      setEditSelected({ ...editSelected, [timestamp]: data });
      return data;
    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };
  const handleAdviceAdd = async (e) => {
    e.preventDefault();
    let error = false;
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      error = true;
    }
    setValidated(true);
    if (error) return false;
    let itemSelected;
    itemSelected = typeAheadSelection[0];
    fields.forEach((field) => {
      itemSelected[field.ref] =
        field.controlType === "check"
          ? adviceRef.current[field.ref].checked
          : adviceRef.current[field.ref].value;
    });

    itemSelected = {
      ...itemSelected,
      timestamp: Date.now(),
      files: adviceRef.current["files"].files,
      key: 0,
      ...extraData,
    };
    if (extraReferences !== undefined && extraReferences.length > 0) {
      extraReferences.forEach((ref) => {
        itemSelected[ref.current.name] = ref.current.value;
      });
    }
    // setTypeAheadSelection([]);
    try {
      const url = adviceSubmitUrl;

      const formData = new FormData();
      // var fileArray = [];
      for (const file of itemSelected.files) {
        formData.append("files", file);
      }
      // for (let i = 0; i < itemSelected.files.length; i++) {
      //   fileArray.push(itemSelected.files[i]);
      //   formData.append("files" , itemSelected.files[i]);
      // }

      formData.append("obj", JSON.stringify({ ...itemSelected, files: [] }));
      await api
        .post(url, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => response.data)
        .then((data) => {
          // Handle the response data
          // console.log(data);
          itemSelected = data.response;
          setAdviceNoted({ type: "add", key: key, data: itemSelected });

          form.reset();
          adviceRef.current.search.clear();
          setValidated(false);
          setTypeAheadSelection([]);
        })
        .catch((error) => {
          // Handle any errors
          console.log(error);
          // setIsLoading("error");
        });
    } catch (error) {
      setIsLoading("error");
    }
  };

  const handleAdviceUpdate = async (e, timestamp) => {
    e.preventDefault();
    let error = false;
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      error = true;
    }
    setEditFormValidated(true);
    if (error) return false;
    const oldAdvice = {
      ...adviceNoted[key].find((s) => s.timestamp === timestamp),
    };
    let itemSelected = editSelected[timestamp][0];
    //itemSelected.files = oldAdvice.files;
    fields.forEach((field) => {
      itemSelected[field.ref] =
        field.controlType === "check"
          ? adviceRef.current[field.ref + "_" + timestamp].checked
          : adviceRef.current[field.ref + "_" + timestamp].value;
    });
    let fileList = adviceRef.current[`files_${timestamp}`].files;
    if (fileList.length > 0)
      itemSelected["files"] = adviceRef.current[`files_${timestamp}`].files;

    itemSelected = {
      ...oldAdvice,
      ...itemSelected,
      oldFiles: oldAdvice.files,
    };

    try {
      const url = adviceSubmitUrl;

      const formData = new FormData();

      for (let i = 0; i < itemSelected.files.length; i++) {
        formData.append("files[]", itemSelected.files[i]);
      }
      formData.append("obj", JSON.stringify({ ...itemSelected, files: [] }));
      await fetch(url, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          // Handle the response data

          itemSelected = data;
          setAdviceNoted({
            type: "update",
            key: key,
            timestamp: timestamp,
            data: itemSelected,
          });

          handleExpandRow(timestamp);
        })
        .catch((error) => {
          // Handle any errors
          console.log(error);
          setIsLoading("error");
        });
    } catch (error) {
      setIsLoading("error");
    }
  };

  const [expandedRows, setExpandedRows] = useState([]);
  // State variable to keep track which row is currently expanded.
  const [expandState, setExpandState] = useState({});
  const [editSelected, setEditSelected] = useState({});
  const handleExpandRow = (timestamp) => {
    const currentExpandedRows = expandedRows;
    const isRowExpanded = currentExpandedRows.includes(timestamp);
    if (isRowExpanded === false)
      setEditSelected({
        ...editSelected,
        [timestamp]: [adviceNoted[key].find((p) => p.timestamp === timestamp)],
      });
    let obj = expandState;
    isRowExpanded ? (obj[timestamp] = false) : (obj[timestamp] = true);
    setExpandState(obj);

    // If the row is expanded, we are here to hide it. Hence remove
    // it from the state variable. Otherwise add to it.
    let newExpandedRows = [];
    if (isRowExpanded)
      newExpandedRows = currentExpandedRows.filter((row) => row !== timestamp);
    else newExpandedRows = currentExpandedRows.concat(timestamp);

    setExpandedRows(newExpandedRows);
  };
  const handleAdviceEdit = (timestamp) => {
    let obj = expandState;
    obj[timestamp] = "edit";
    setExpandState({ ...obj });
  };

  return (
    <>
      <Card className="mb-3 rounded-0 inner-card" border={variant} id={id}>
        <Card.Header
          className={"rounded-0 bg-" + variant + " text-white print-black"}
          as="h5"
        >
          {adviceType}
        </Card.Header>
        <Card.Body>
          {isLoading === true ? (
            <Loading />
          ) : isLoading === "error" ? (
            <Loading failed={true} />
          ) : (
            <>
              {newEntryForm && (
                <Form
                  noValidate
                  validated={isValidated}
                  onSubmit={(e) => handleAdviceAdd(e)}
                  className="d-print-none"
                >
                  <fieldset>
                    <Row sm={3}>
                      <Col md={4}>
                        <Form.Group className="mb-3">
                          <Form.Label>{adviceType}</Form.Label>
                          <AsyncTypeahead
                            isLoading={typeAheadLoading}
                            labelKey="bp_service_name"
                            onChange={setTypeAheadSelection}
                            onSearch={handleSearch}
                            options={typeAheadSelection}
                            id={typeaheadId}
                            ref={(el) => (adviceRef.current["search"] = el)}
                            inputProps={{ required: true }}
                          />
                        </Form.Group>
                      </Col>
                      {fields.map((field, index) => {
                        return (
                          <React.Fragment key={index}>
                            <Col key={index}>
                              <Form.Group className="mb-3">
                                <Form.Label>{field.label}</Form.Label>
                                {field.controlType === undefined && (
                                  <Form.Control
                                    {...field.props}
                                    ref={(el) =>
                                      (adviceRef.current[field.ref] = el)
                                    }
                                  />
                                )}
                                {field.controlType === "select" && (
                                  <Form.Select
                                    {...field.props}
                                    ref={(el) =>
                                      (adviceRef.current[field.ref] = el)
                                    }
                                  >
                                    {field.data.map((option, index) => {
                                      return (
                                        <option
                                          value={option.value}
                                          key={index}
                                        >
                                          {option.label}
                                        </option>
                                      );
                                    })}
                                  </Form.Select>
                                )}
                                {field.controlType === "check" && (
                                  <Form.Check
                                    {...field.props}
                                    ref={(el) =>
                                      (adviceRef.current[field.ref] = el)
                                    }
                                  />
                                )}
                              </Form.Group>
                            </Col>
                          </React.Fragment>
                        );
                      })}
                      <Col>
                        <Form.Group className="mb-3">
                          <Form.Label>Files</Form.Label>
                          <Form.Control
                            type="file"
                            multiple
                            ref={(el) => (adviceRef.current["files"] = el)}
                          />
                        </Form.Group>
                      </Col>

                      <Col lg={12} className="text-end mb-3">
                        <Button type="submit" variant={variant}>
                          Add
                        </Button>
                      </Col>
                    </Row>
                  </fieldset>
                </Form>
              )}
              <Table bordered>
                <colgroup>
                  <col style={{ width: "110px" }} />
                  <col style={{ width: "15%" }} />
                  <col
                    span={
                      fields.filter(
                        (f) => f.hidden === undefined || f.hidden === false
                      ).length
                    }
                  />
                  <col style={{ width: "75px" }} className="d-print-none" />
                  {/* <col style={{ width: "50%" }} /> */}
                </colgroup>
                <thead>
                  {thGroups && thGroups.length > 0 && (
                    <tr>
                      <th></th>
                      {thGroups.map(({ label, colspan }, index) => {
                        return (
                          <th key={index} colSpan={colspan}>
                            {label}
                          </th>
                        );
                      })}
                      <th></th>
                    </tr>
                  )}
                  <tr>
                    <th>Date</th>
                    <th className="col-md-3">Name</th>
                    {fields.map((field, index) => {
                      return (
                        <React.Fragment key={index}>
                          {!field.hidden && <th key={index}>{field.label}</th>}
                        </React.Fragment>
                      );
                    })}
                    <th>File</th>
                  </tr>
                </thead>
                <tbody>
                  {adviceNoted[key].map((advice) => {
                    return (
                      <React.Fragment key={advice.timestamp}>
                        <tr
                          className={
                            expandState[advice.timestamp] === true
                              ? "table-warning"
                              : expandState[advice.timestamp] === "edit"
                              ? "table-danger"
                              : ""
                          }
                        >
                          <td>
                            <DateFormat value={advice.erxDate} />
                          </td>
                          <td
                            className="col-md-1"
                            role="button"
                            onClick={() => handleExpandRow(advice.timestamp)}
                          >
                            <strong>{advice.bp_service_name}</strong>
                          </td>
                          {fields.map((field, index) => {
                            return (
                              <React.Fragment key={index}>
                                {!field.hidden && (
                                  <td>
                                    {field.controlType === "check" ? (
                                      <Form.Check
                                        checked={advice[field.ref]}
                                        disabled
                                      />
                                    ) : (
                                      advice[field.ref]
                                    )}
                                  </td>
                                )}
                              </React.Fragment>
                            );
                          })}
                          <td>
                            {advice.files.length >= 1 && (
                              <Dropdown>
                                <Dropdown.Toggle
                                  size="sm"
                                  variant={variant}
                                  id={`filelistbutton${advice.timestamp}`}
                                >
                                  Files
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                  {Array.from(advice.files).map(
                                    (file, index) => {
                                      return (
                                        <Dropdown.Item
                                          as="a"
                                          href={
                                            process.env.REACT_APP_API_ENDPOINT +
                                            "/file/" +
                                            file
                                          }
                                          key={index}
                                          target="_blank"
                                        >
                                          {file}
                                        </Dropdown.Item>
                                      );
                                    }
                                  )}
                                </Dropdown.Menu>
                              </Dropdown>
                            )}
                          </td>
                        </tr>
                        {expandedRows.includes(advice.timestamp) && (
                          <tr className="d-print-none">
                            <td colSpan={fields.length + 3}>
                              <Form
                                noValidate
                                validated={editFormValidated}
                                onSubmit={(e) =>
                                  handleAdviceUpdate(e, advice.timestamp)
                                }
                              >
                                <fieldset>
                                  <Row sm={3}>
                                    <Col md={4}>
                                      <Form.Group className="mb-3">
                                        <Form.Label>{adviceType}</Form.Label>
                                        <AsyncTypeahead
                                          labelKey="name"
                                          options={
                                            editSelected[advice.timestamp]
                                          }
                                          onSearch={(query) =>
                                            handleEditSearch(
                                              query,
                                              advice.timestamp
                                            )
                                          }
                                          id={typeaheadId + advice.timestamp}
                                          ref={(el) =>
                                            (adviceRef.current[
                                              "search_" + advice.timestamp
                                            ] = el)
                                          }
                                          onChange={(selected) => {
                                            setEditSelected({
                                              ...editSelected,
                                              [advice.timestamp]: selected,
                                            });
                                          }}
                                          placeholder="Search..."
                                          inputProps={{ required: true }}
                                          defaultSelected={[advice]}
                                          disabled={
                                            expandState[advice.timestamp] ===
                                            true
                                          }
                                        />
                                      </Form.Group>
                                    </Col>
                                    {fields.map((field, index) => {
                                      return (
                                        <React.Fragment key={index}>
                                          <Col key={index}>
                                            <Form.Group className="mb-3">
                                              <Form.Label>
                                                {field.label}
                                              </Form.Label>

                                              {field.controlType ===
                                                undefined && (
                                                <Form.Control
                                                  {...field.props}
                                                  ref={(el) =>
                                                    (adviceRef.current[
                                                      field.ref +
                                                        "_" +
                                                        advice.timestamp
                                                    ] = el)
                                                  }
                                                  defaultValue={
                                                    advice[field.ref]
                                                  }
                                                  readOnly={
                                                    expandState[
                                                      advice.timestamp
                                                    ] === true
                                                  }
                                                />
                                              )}
                                              {field.controlType ===
                                                "select" && (
                                                <Form.Select
                                                  {...field.props}
                                                  ref={(el) =>
                                                    (adviceRef.current[
                                                      field.ref +
                                                        "_" +
                                                        advice.timestamp
                                                    ] = el)
                                                  }
                                                  defaultValue={
                                                    advice[field.ref]
                                                  }
                                                  disabled={
                                                    expandState[
                                                      advice.timestamp
                                                    ] === true
                                                  }
                                                >
                                                  {field.data.map(
                                                    (option, index) => {
                                                      return (
                                                        <option
                                                          value={option.value}
                                                          key={index}
                                                        >
                                                          {option.label}
                                                        </option>
                                                      );
                                                    }
                                                  )}
                                                </Form.Select>
                                              )}
                                              {field.controlType ===
                                                "check" && (
                                                <Form.Check
                                                  {...field.props}
                                                  ref={(el) =>
                                                    (adviceRef.current[
                                                      field.ref +
                                                        "_" +
                                                        advice.timestamp
                                                    ] = el)
                                                  }
                                                  defaultChecked={
                                                    advice[field.ref]
                                                  }
                                                  disabled={
                                                    expandState[
                                                      advice.timestamp
                                                    ] === true
                                                  }
                                                />
                                              )}
                                            </Form.Group>
                                          </Col>

                                          <Col>
                                            <Form.Group className="mb-3">
                                              <Form.Label>Files</Form.Label>
                                              <Form.Control
                                                type="file"
                                                multiple
                                                ref={(el) =>
                                                  (adviceRef.current[
                                                    `files_${advice.timestamp}`
                                                  ] = el)
                                                }
                                                disabled={
                                                  expandState[
                                                    advice.timestamp
                                                  ] === true
                                                }
                                              />
                                              <Form.Text>
                                                Leave blank to keep file
                                                unchanged.
                                              </Form.Text>
                                            </Form.Group>
                                          </Col>
                                        </React.Fragment>
                                      );
                                    })}

                                    <Col lg={12} className="text-end mb-3">
                                      {expandState[advice.timestamp] ===
                                        true && (
                                        <Button
                                          type="button"
                                          variant={variant}
                                          onClick={() =>
                                            handleAdviceEdit(advice.timestamp)
                                          }
                                        >
                                          Edit
                                        </Button>
                                      )}
                                      {expandState[advice.timestamp] ===
                                        "edit" && (
                                        <>
                                          <input
                                            type="hidden"
                                            ref={(el) =>
                                              (adviceRef.current[
                                                "timestamp_" + advice.timestamp
                                              ] = el)
                                            }
                                          />
                                          <Button
                                            type="button"
                                            variant="outline-danger"
                                            className="ms-3"
                                            onClick={() =>
                                              handleExpandRow(advice.timestamp)
                                            }
                                          >
                                            Cancel
                                          </Button>
                                          <Button
                                            type="submit"
                                            className="ms-3"
                                            variant={`outline-${variant}`}
                                          >
                                            Update
                                          </Button>
                                        </>
                                      )}
                                    </Col>
                                  </Row>
                                </fieldset>
                              </Form>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </Table>
            </>
          )}
        </Card.Body>
      </Card>
    </>
  );
}

export default ErxAdvices;
